import { makeObservable, observable, action, computed } from "mobx";

import { ToastHelper } from "helpers/ToastHelper";
import { CompanyFeaturesModel } from "models/company/entities/CompanyFeaturesModel";
import CompanyAPI from "services/CompanyAPI";

/**
 * Store responsável por gerenciar os dados e funcionalidades da Empresa.
 */
class CompanyStore {
  // --- Propriedades Observáveis (Estado) ---
  companyFeatures?: CompanyFeaturesModel;
  loading: boolean = false;

  constructor() {

    // Torna as propriedades da classe reativas com MobX
    makeObservable(this, {
      // Estado observável
      companyFeatures: observable,
      loading: observable,

      // Ações que modificam o estado
      reset: action,
      emptyCompany: action,
      getFeatures: action,
    });
  }


  // --- Ações (Métodos que modificam o Estado) ---

  /**
   * Reseta o estado da store para os valores iniciais.
   */
  reset(): void {
    this.companyFeatures = undefined;
    this.loading = false;
  }

  /**
   * Cria uma nova instância vazia de CompanyFeaturesModel.
   */
  emptyCompany(): void {
    this.companyFeatures = undefined;
  }

  /**
   * Busca as configurações (features) da empresa na API.
   */
  async getFeatures(): Promise<void> {
    this.loading = true;
    try {
      const response = await CompanyAPI.getFeatures();

      if (response.error) {
        ToastHelper.error({ message: response.error });
        this.companyFeatures = undefined;
      } else {
        this.companyFeatures = new CompanyFeaturesModel(response);
      }
    } catch (error: any) {
      ToastHelper.error({ message: "Ocorreu um erro ao buscar as configurações." });
      console.error("Falha em getFeatures:", error);
    } finally {
      this.loading = false;
    }
  }
}
export default CompanyStore;